export const SERVER_URL =
  process.env.REACT_APP_ENV === "prod"
    ? "https://goback-api.sealwith.me"
    : "http://localhost:3002";

export const CLIENT_URL =
  process.env.REACT_APP_ENV === "prod"
    ? "https://go-back.me"
    : "http://localhost:3000";
